import { render, staticRenderFns } from "./Fireform.vue?vue&type=template&id=13bd90c9&scoped=true&"
import script from "./Fireform.vue?vue&type=script&lang=js&"
export * from "./Fireform.vue?vue&type=script&lang=js&"
import style0 from "./Fireform.vue?vue&type=style&index=0&id=13bd90c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd90c9",
  null
  
)

export default component.exports